/**
 * Groups schema (Phase 1 - Hierarchical Join Link System plan)
 *
 * Defines group types and shape for the org-wide team graph.
 * Full groups collection and groupJoinRequests can be introduced in phase 1
 * and populated during migration. This file provides the contract.
 *
 * @see hierarchical_join_link_system_ce8e8d3e.plan.md
 */

export const GROUP_TYPES = {
  ORGANIZATION: 'organization',
  FACILITY: 'facility',
  DEPARTMENT: 'department',
  CLINIC: 'clinic',
  CHARTMIND_ADMIN_DESIGNEE: 'chartmind-admin-designee',
  SYSTEM_ORG: 'system_org',
};

export const MAX_DEPTH = 12;

/** System/org group ID for group-scoped system invitations (plan: no global user.role for invited roles). */
export const SYSTEM_ORG_GROUP_ID = 'system-org';

/**
 * Shape of a group document (for groups collection when introduced).
 * @typedef {Object} GroupDoc
 * @property {string} groupId
 * @property {string[]} parentGroupIds - empty for roots
 * @property {string} type - one of GROUP_TYPES
 * @property {string} name - required
 * @property {Object} [metadata] - e.g. facilityId, departmentId, clinicId for backward compat
 */
